var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 97,
    viewBox: "0 0 440 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.783203,
    y: 0.0820312,
    width: 439,
    height: 96,
    rx: 12,
    fill: "url(#paint0_linear_98_132)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_98_132",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 440,
    height: 97
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.2832,
    y: 0.582031,
    width: 438,
    height: 95,
    rx: 11.5,
    fill: "url(#paint1_linear_98_132)",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_98_132)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_98_132)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 135.086,
    ry: 115.822,
    transform: "matrix(0.89048 -0.455023 0.526064 0.850445 345.629 4.08354)",
    fill: "#667EEA",
    fillOpacity: 0.53
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_98_132)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 69.6319,
    ry: 66.5225,
    transform: "matrix(0.473262 -0.880922 0.914032 0.405641 246.376 48.1435)",
    fill: "#667EEA",
    fillOpacity: 0.53
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_98_132)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 129.026,
    ry: 109.574,
    transform: "matrix(0.89048 -0.455023 0.526064 0.850445 345.068 2.21518)",
    fill: "#667EEA",
    fillOpacity: 0.53,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_98_132)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 66.5082,
    ry: 62.9342,
    transform: "matrix(0.473262 -0.880922 0.914032 0.405641 245.489 47.4645)",
    fill: "#667EEA",
    fillOpacity: 0.53,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_98_132",
    x: 210.758,
    y: -115.789,
    width: 269.743,
    height: 235.993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.75104
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.6888
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_98_132"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_98_132",
    x: 177.203,
    y: -22.6376,
    width: 138.346,
    height: 137.811,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.75104
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.6888
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_98_132"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_98_132",
    x: 214.62,
    y: -107.938,
    width: 260.896,
    height: 224.058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.87552
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.937759
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0.67 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_98_132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_98_132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_98_132",
    x: 178.029,
    y: -16.4604,
    width: 134.92,
    height: 131.601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.87552
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.937759
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0.67 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_98_132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_98_132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_98_132",
    x1: 439.783,
    y1: 4.519,
    x2: 388.059,
    y2: 202.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#764BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667EEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_98_132",
    x1: 439.783,
    y1: 4.519,
    x2: 388.059,
    y2: 202.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#764BA2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateBackground);
export default __webpack_public_path__ + "static/media/create_background.a313ca746b691d1fa8bb4fbaab03c26c.svg";
export { ForwardRef as ReactComponent };